import type { EventItem } from "@shared/types";
import { Link } from "react-router-dom";
import { StatusBadge } from "@/components/status-badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatRelative } from "@/lib/utils";

export function MonitorEventTable({ events }: { events: EventItem[] }) {
  if (events.length === 0) {
    return <p className="py-8 text-center text-sm text-muted-foreground">No recent status changes.</p>;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Time</TableHead>
          <TableHead>Monitor</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Message</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {events.map(event => (
          <TableRow key={event.id}>
            <TableCell className="whitespace-nowrap text-muted-foreground">
              {formatRelative(event.checkedAt)}
            </TableCell>
            <TableCell className="max-w-44">
              <Link
                to={`/monitors/${event.monitorId}`}
                className="block truncate font-medium hover:underline"
              >
                {event.monitorName}
              </Link>
            </TableCell>
            <TableCell>
              <StatusBadge status={event.status} />
            </TableCell>
            <TableCell className="max-w-80 truncate text-muted-foreground">
              {event.message || "—"}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
